<template>
    <v-container>
        <v-row>
            <v-col
                cols="12"
                sm="6"
            >
                <v-img
                    class="my-5"
                    :src="require('../assets/not_found.svg')"
                />
            </v-col>
            <v-col
                class="text-center text-sm-left"
                cols="12"
                sm="6"
            >
                <div class="d-flex flex-column fill-height justify-center">
                    <h1>Not Found</h1>
                    <p class="body-1">
                        The Page you are looking for could not be found.
                    </p>
                    <p class="body-1">
                        Please return to the homepage or contact us.
                    </p>
                    <div>
                        <v-btn
                            class="mr-3"
                            color="primary"
                            :to="{name: 'home'}"
                        >
                            Homepage
                        </v-btn>
                        <v-btn
                            color="primary"
                            outlined
                            :to="{name: 'contactUs'}"
                        >
                            Contact Us
                        </v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {

}
</script>
